
import { Options, Vue } from 'vue-class-component';
import {Prop} from "vue-property-decorator";

@Options({
  props: {
    modelValue: Number,
  }
})
export default class CountryPicker extends Vue {
  @Prop({default: ['','','']})
  labels!: string[]
  modelValue!: number;

  incrementValue(){
    this.$emit("input",this.modelValue + 1);
    this.$emit("update:modelValue", this.modelValue + 1);
  }

  decrementValue(){
    this.$emit("input",Math.max(this.modelValue - 1,1));
    this.$emit("update:modelValue", Math.max(this.modelValue - 1,1));
  }

  declOfNum(number: number, words: string[]){
    return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
  }
}
